import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {fetchConnectionDocumentDetail} from "../services/document-service";

export const useConnectionDocumentDetail = ({type, documentId}) => {
    const {loggedCompany} = useSelector((state) => state.user ?? {});
    const companyId = loggedCompany?.id;

    const [document, setDocument] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!companyId || !type || !documentId) {
            setDocument(null);
            setIsLoading(false);
            return;
        }

        const controller = new AbortController();
        const {signal} = controller;

        const loadDetail = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await fetchConnectionDocumentDetail({
                    companyId,
                    type,
                    documentId,
                    signal,
                });
                setDocument(response ?? null);
            } catch (err) {
                if (!signal.aborted) {
                    setError(err);
                    setDocument(null);
                }
            } finally {
                if (!signal.aborted) {
                    setIsLoading(false);
                }
            }
        };

        loadDetail();

        return () => controller.abort();
    }, [companyId, documentId, type]);

    return {
        companyId,
        document,
        isLoading,
        error,
    };
};

